import type ISchoolPeriodRepository from '@/core/domain/school/period/ISchoolPeriodRepository'
import SchoolPeriod, { SchoolPeriodInput } from '@/core/domain/school/period/SchoolPeriod'
import { apiService } from '@/core/infrastructure/services/apiServiceFactory'
import type {
  SchoolPeriodFetchAndCreateResponseEntity
} from '@/core/infrastructure/schemas/school/period/SchoolPeriodSchema.ts'
import { UserRole } from '@/core/domain/resources/enums/UserRole.ts'

export default class SchoolPeriodRepository implements ISchoolPeriodRepository {
  async fetchAllSchoolPeriods(schoolId: number): Promise<SchoolPeriod[]> {
    const response = await apiService.get(`admin/schools/${schoolId}/periods`)

    if (!Array.isArray(response.data)) {
      throw new Error('Expected array response for school periods')
    }

    return response.data.map((schoolPeriod) => SchoolPeriod.create(schoolPeriod))
  }

  /**
   * Mapping du résultat pour retourner une forme similaire à fetchSchoolPeriodById(schoolId)
   * @param schoolPeriod
   */
  async createSchoolPeriod(schoolPeriod: SchoolPeriodInput): Promise<SchoolPeriod> {
    const response = await apiService.post<SchoolPeriodFetchAndCreateResponseEntity>(
      `admin/schools/${schoolPeriod.schoolId}/periods`,
      {
        schoolId: schoolPeriod.schoolId,
        schoolYearId: schoolPeriod.schoolYearId
      }
    )

    // Pour createSchoolPeriod, la réponse a une structure spéciale que nous devons transformer
    if (response.data?.schoolPeriodId && response.data?.schoolYear && response.data?.users) {
      const schoolPeriodData = {
        schoolPeriodId: response.data.schoolPeriodId,
        schoolId: response.data.schoolId,
        schoolYear: response.data.schoolYear,
        countStudents: response.data.users
          .filter((periodUser) => periodUser.user.roles.includes(UserRole.Values.STUDENT)).length,
        countTeachers: response.data.users
          .filter((periodUser) => periodUser.user.roles.includes(UserRole.Values.TEACHER)).length,
        countClassrooms: 0
      }
      return SchoolPeriod.create(schoolPeriodData)
    }

    throw new Error('Invalid response format for school period creation')
  }

}
